const HOST = "apps.cosy.bio"
export const CONTEXT_PATH="/api-proharmed/"
// export const BACKEND_PORT= "8080"
export const HOST_URL = "https://" + HOST //+ ":" + BACKEND_PORT
export const PATH_PREFIX= "/proharmed/"
export const STATIC_PATH="/proharmed/static/"
